import { Card, QRCode, Tag} from "antd";
import React from 'react';
import './EnrollAuthicatorApp.css';

const ConfigurationQRCode: React.FC<{
    qrCode: string;
    secret: string;
}> = ({ qrCode, secret}) => {
    return (
          <Card >
            <div className="qrcode-section">
                <h2>Configuration QR Code</h2>
              <h4>Scan the below QR Code with your authenticator app</h4>
              <QRCode 
                value={qrCode} 
                size={320} 
                style={{marginTop:'20px', marginBottom:'20px'}}
                icon="https://storage.googleapis.com/tenderd-ui/assets/÷logo-square.svg"
                iconSize={27}
                />
              <h4>Or enter the below key in your authenticator app</h4>
              <Tag className="custom-tag" color="blue">{secret}</Tag>
            </div>
          
          </Card>
    );

};

export default ConfigurationQRCode